import { http } from './http'

export type PackageMenuPermissionDto = { menuKey: string; recordLimit?: number | null }
export type PackageCreateUpdateDto = {
  name: string
  price: number
  isActive: boolean
  description?: string | null
  permissions: PackageMenuPermissionDto[]
}
export type ActivePackageDto = {
  packageId: number
  packageName: string
  permissions: PackageMenuPermissionDto[]
  apiPermissions: { key: string; description: string; groupName: string }[]
}

export const TenantPackagesApi = {
  active: () => http.get('/api/tenantPackages/active'),

  warning: () => http.get('/api/packages/warning'),
}
